import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { exhaustMap, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { GcpService } from '../../state-services/gcp.service';
import {
  creatingGcpAssetsError,
  creatingGcpAssetsSuccess,
  loadingGcpAssets,
  loadingGcpAssetsError,
  loadingGcpAssetsSuccess,
} from './gcp.actions';
import * as GcpActions from './gcp.actions';
import * as CompanyActions from '../company/company.actions';

@Injectable()
export class GcpEffects {
  loadingGcpAssets$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadingGcpAssets),
      exhaustMap(() =>
        this.gcpService.getGroundControlPoints().pipe(
          map((gcps) => loadingGcpAssetsSuccess({ groundControlPoints: gcps })),
          catchError((error) => of(loadingGcpAssetsError({ error: error }))),
        ),
      ),
    ),
  );

  createGcpAsset$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GcpActions.createGcpAssets),
      mergeMap(({ groundControlPoints }) =>
        this.gcpService.createGroundControlPoints(groundControlPoints).pipe(
          map((response) => {
            return creatingGcpAssetsSuccess({ groundControlPoints: response });
          }),
          catchError((error) => of(creatingGcpAssetsError({ error }))),
        ),
      ),
    ),
  );

  deleteGcp$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GcpActions.deleteGcp),
      exhaustMap(({ gcpId }) =>
        this.gcpService.deleteGroundControlPoint(gcpId).pipe(
          map(() => GcpActions.deleteGcpSuccess({ gcpId: gcpId })),
          catchError((error) =>
            of(CompanyActions.deleteMemberError({ error: error })),
          ),
        ),
      ),
    ),
  );

  editGcpAsset$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GcpActions.editGcp),
      mergeMap(({ id, changes }) =>
        this.gcpService.editGroundControlPoints(id, changes).pipe(
          map((response) => {
            console.log(
              'API call succeeded, dispatching editGcpSuccess:',
              response,
            );
            return GcpActions.editGcpSuccess({ groundControlPoint: response });
          }),
          catchError((error) => {
            console.log('API call failed:', error);
            return of(GcpActions.editGcpError({ error }));
          }),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private gcpService: GcpService,
  ) {}
}
